import InputTextNewTheme from "@/components/input/InputTextNewTheme";
import InputTelephoneWithCountry from "@/components/input/InputTelephoneWithCountry";
export default {
  props: {
    title: {
      required: false,
      type: String
    },
    description: {
      required: false,
      type: String
    },
    form: {
      required: true,
      type: Object
    },
    v: {
      required: true,
      type: Object
    },
    isValidate: {
      required: true,
      type: Boolean
    },
    vEmail: {
      required: true,
      type: Object
    },
    isValidateEmail: {
      required: true,
      type: Boolean
    },
    show: {
      required: false,
      default: true
    },
    disabledCountry: { required: false, type: Boolean, default: false }
  },
  components: {
    InputTextNewTheme,
    InputTelephoneWithCountry
  },
  data() {
    return {
      telSubTitle: this.$t("telephone_subtitle"),
      emailSubTitle: this.$t("email_subtitle"),
      country: "1"
    };
  },
  computed: {
    validTelephone() {
      if (this.form.login_type == 1) {
        const countryId = this.form.telephone_country_id;
        const config = this.$config;
        const country = config.telephone_country.find(el => el.id == countryId);
        if (!country) return true;
        console.log(this.form, country);
        if (this.form.Telephone.length == country.phone_length) return true;
        return false;
      }
      return true;
    },
    formattedTelSubTitle() {
      const text = this.description || this.telSubTitle || "";
      return text.replace(/\\n/g, "\n"); // <<-- สำคัญ!
    },
    formattedEmailSubTitle() {
      const text = this.description || this.emailSubTitle || "";
      return text.replace(/\\n/g, "\n"); // <<-- สำคัญ!
    }
  },
  methods: {
    telTitle() {
      if (this.form.login_type == 1) return this.$t("telephone_title");
      else return this.$t("email_title");
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    input(e) {
      if (e.target.value.length > 10) {
        e.target.value = e.target.value.slice(0, 10);
        this.form.Telephone = e.target.value;
        return e.preventDefault();
      }
    }
  }
};
